var moment = require('moment');

/*
* Note: context here is notesCollection, which relies on it's 'sortDir' instance variable
* */

module.exports = {

    ctime: {

        name: 'Time Created',
        sortFn: function (a, b) {

            var aMoment = moment(a.get('creationTime')),
                bMoment = moment(b.get('creationTime')),
                diff = aMoment.diff(bMoment); // milliseconds

            //moment: If the moment is later than the moment you are passing to moment.fn.diff, the return value will be negative
            if (this.sortDir === 'desc') {
                if (diff < 0) {
                    return 1;
                } else if (diff > 0) {
                    return -1;
                } else {
                    return 0;
                }
            } else {  //asc
                if (diff < 0) {
                    return -1;
                } else if (diff > 0) {
                    return 1;
                } else {
                    return 0;
                }
            }
        }

    },

    cusr: {

        name: 'Creation User',
        /*
         * TODO: this is example of string descending; encapsulate into fn
         */
        sortFn: function (a, b) {

            if (this.sortDir === 'asc') {

                if (a.get('creationUserDesc') > b.get('creationUserDesc')) {
                    return 1;
                }
                else if (a.get('creationUserDesc') < b.get('creationUserDesc')) {
                    return -1;
                }
                else {
                    return 0;
                }

            } else {

                if (a.get('creationUserDesc') > b.get('creationUserDesc')) {
                    return -1;
                }
                else if (a.get('creationUserDesc') < b.get('creationUserDesc')) {
                    return 1;
                }
                else {
                    return 0;
                }
            }
        }
    },

    type: {

        name: 'Type',
        sortFn: function (a, b) {
            if (this.sortDir === 'asc') {
                if (a.noteTypeGroup > b.noteTypeGroup) {
                    return 1;
                }
                else if (a.noteTypeGroup < b.noteTypeGroup) {
                    return -1;
                } else {
                    return 0;
                }
            } else {
                if (a.noteTypeGroup > b.noteTypeGroup) {
                    return -1;
                }
                else if (a.noteTypeGroup < b.noteTypeGroup) {
                    return 1;
                } else {
                    return 0;
                }
            }

        }

    },
    /*
     * (Numeric example)
     */
    pageNumber: {
        name: 'Page',
        sortFn: function (a) {
            if (this.sortDir === 'asc') {
                return a.pageNumber;
            } else {
                return -a.pageNumber;
            }
        }
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/comparators.js
 ** module id = 274
 ** module chunks = 0
 **/